import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../Context/GlobalContext";
// import storage from "../Assets/js/Global";
import { useLocation } from "react-router-dom";
import storage from "../Assets/js/Global";

const ExportScanApprove = () => {
  const {
    translatedLabels,
    userEmail,
    globalUserEmail,
    exportScanDetails,
    setGlobalUserEmail,
    verifiedsecEmail,
    is4Life,
  } = useContext(GlobalContext);
  const screenLabels = translatedLabels?.common;
  const authLabel = translatedLabels?.auth;

  // let scanID = "";
  // useEffect(() => {
  //   scanID = storage.get("scanId");
  // });

  const location = useLocation();
  const { scanId, documentIds } = location.state || {};
  const guestEmail = storage.get("guestEmail");
  const scanGuest = storage.get("scanGuest");
  const [enteredEmail, setEnteredEmail] = useState(
    is4Life ? verifiedsecEmail : scanGuest ? guestEmail : userEmail,
  );
  const [isChecked, setIsChecked] = useState(false);
  const [requiresConsent, setRequiresConsent] = useState(false);

  useEffect(() => {
    const baseEmail = is4Life
      ? verifiedsecEmail
      : scanGuest
        ? guestEmail
        : userEmail;

    if (enteredEmail && enteredEmail !== baseEmail) {
      setRequiresConsent(true);
      setGlobalUserEmail(enteredEmail || userEmail);
    } else {
      setRequiresConsent(false);
      setIsChecked(false);
      setGlobalUserEmail("");
    }
  }, [enteredEmail, userEmail, verifiedsecEmail, scanGuest, is4Life]);

  useEffect(() => {}, [globalUserEmail]);

  // const handleApprove = (exportType) => {
  //   exportScanDetails(
  //     enteredEmail || userEmail,
  //     scanId,
  //     documentIds,
  //     exportType,
  //   );
  // };

  const handleApprove = (exportType) => {
    const finalEmail = enteredEmail || (is4Life ? verifiedsecEmail : userEmail);

    exportScanDetails(finalEmail, scanId, documentIds, exportType);
  };

  return (
    <div className="content-part">
      <div className="info-part mb-2">
        <p className="mb-2 text-muted">
          {screenLabels?.email_confirm_privacy?.label_value ||
            "Please confirm your email address to receive the report."}
        </p>
      </div>

      <div className="mb-3">
        <label className="form-label">
          {screenLabels?.email?.label_value || "Email"}
        </label>
        <input
          type="email"
          className="form-control"
          value={enteredEmail}
          onChange={(e) => setEnteredEmail(e.target.value)}
          placeholder="Enter your email"
        />
      </div>
      <div>
        <p className="fs-14px mb-0">
          <span className="fw-semibold">
            {authLabel?.note?.label_value || "Note"}:
          </span>
          {authLabel?.export_note?.label_value ||
            "After clicking export, please check your provided email to get the report."}
        </p>
      </div>
      {requiresConsent && (
        <div className="mb-3 mt-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="hipaaConsent"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            <label htmlFor="hipaaConsent">
              <p className="fs-15px">
                {screenLabels?.privacy_consent_1?.label_value ||
                  "I understand that by choosing to share my report via email, I am authorizing the disclosure of my personal health information to the recipient's I specify."}
              </p>
            </label>
          </div>
        </div>
      )}

      <div className="d-flex align-items-center justify-content-center mt-3">
        <button
          className="btn btn-primary py-2"
          disabled={requiresConsent ? !isChecked : false}
          onClick={() => handleApprove("Scan")}
        >
          {authLabel?.export?.label_value || "Export"}
        </button>
      </div>
    </div>
  );
};

export default ExportScanApprove;
